import {
  call,
  put, takeLatest,
} from 'redux-saga/effects';
import { select } from '../../../../../_shared/utils/saga/effects';
import { type PickAction } from '../../../../../_shared/utils/types/action.type';
import { type BoundaryItemsAction } from '../../../../boundaryItems/boundaryItems.action';
import { BOUNDARY_ITEMS_REMOVE_ITEM_RESPONSE_RECEIVED } from '../../../../boundaryItems/boundaryItems.actionTypes';
import { type BoundaryTerritoryGroupsAction } from '../../../../boundaryTerritoryGroups/boundaryTerritoryGroups.action';
import { BOUNDARY_TERRITORY_GROUP_REMOVE_COMPLETED } from '../../../../boundaryTerritoryGroups/boundaryTerritoryGroups.actionTypes';
import { boundaryDrawDeactivate } from './boundaryDraw.actionCreators';
import { boundaryDrawSelector } from './boundaryDraw.selectors';
import {
  BoundaryDrawMode, type BoundaryDrawState, DrawType, isBoundaryDrawActive,
} from './boundaryDraw.state';

export function* boundaryDrawSagas() {
  yield takeLatest(BOUNDARY_TERRITORY_GROUP_REMOVE_COMPLETED, onBoundaryTerritoryGroupRemove);
  yield takeLatest(BOUNDARY_ITEMS_REMOVE_ITEM_RESPONSE_RECEIVED, onBoundaryItemRemove);
}

function* onBoundaryTerritoryGroupRemove(action: PickAction<BoundaryTerritoryGroupsAction, typeof BOUNDARY_TERRITORY_GROUP_REMOVE_COMPLETED>) {
  const boundaryDrawState: BoundaryDrawState = yield select<BoundaryDrawState>(boundaryDrawSelector);
  const { boundaryTerritoryGroups: removedBTGs } = action.payload;

  const activeBtgId = isBoundaryDrawActive(boundaryDrawState) ? boundaryDrawState.drawModeData.boundaryTerritoryGroupId : null;
  if (activeBtgId) {
    if (removedBTGs.some(btg => btg.boundaryTerritoryGroupId === activeBtgId)) {
      yield call(deactivateBoundaryDraw);
    }
  }
  else if (removedBTGs.some(btg => btg.boundaryGroupId === boundaryDrawState.boundaryGroupId)) {
    yield call(deactivateBoundaryDraw);
  }
}

function *onBoundaryItemRemove(action: PickAction<BoundaryItemsAction, typeof BOUNDARY_ITEMS_REMOVE_ITEM_RESPONSE_RECEIVED>) {
  const boundaryDrawState: BoundaryDrawState = yield select<BoundaryDrawState>(boundaryDrawSelector);

  if (
    boundaryDrawState.drawType === DrawType.Drag &&
    boundaryDrawState.drawModeData.mode === BoundaryDrawMode.BoundaryPolygonEdit &&
    boundaryDrawState.drawModeData.boundaryId === action.payload.boundaryId
  ) {
    yield call(deactivateBoundaryDraw);
  }
}

function* deactivateBoundaryDraw() {
  yield put(boundaryDrawDeactivate());
}
